import React, { useEffect } from 'react';
import { MainContainer, MainHeading, ParaText } from '../../style/GlobalStyles';
import { Box, Typography, useTheme } from '@mui/material';
import DocumentCard from '../../components/DocumentCard';
import { useSelector, useDispatch } from 'react-redux';
import { selectLegalTemplatesData, selectLegalTemplatesStatus, selectLegalTemplatesError, initializeAsync } from './legalTemplatesSlice';
import { skeleton } from './skeleton';

const CONSTANTS_JSON_DATA = [
    {
        heading: 'Business Formation & Structure',
        docs: [
            {
                className: 'DocumentLinkWrapper',
                title: 'TestDocument',
                linkedEntityId: 'a6XVB00dfghuio',
                latestPublishedVersionId: '068VB0000fgthyjukAA',
                id: 'edrtyuioert5y6789',
                fileType: 'WORD_X',
                fileExtension: 'docx',
                contentSize: 13117,
                contentDocumentId: 'dfghjkdfghjkl',
                category: null,
            },
            {
                className: 'DocumentLinkWrapper',
                title: 'sunset80280-248159',
                linkedEntityId: 'a6XVB0000007DF32AM',
                latestPublishedVersionId: '068VB0000040xvbYAA',
                id: '06AVB000004YCny2AG',
                fileType: 'JPG',
                fileExtension: 'jpg',
                contentSize: 1277350,
                contentDocumentId: '069VB000003pd2ZYAQ',
                category: null,
            },
            {
                className: 'DocumentLinkWrapper',
                title: 'TestPDF',
                linkedEntityId: 'a6XVB0000007DF32AM',
                latestPublishedVersionId: '068VB000003w5tdYAA',
                id: '06AVB000004YFjM2AW',
                fileType: 'PDF',
                fileExtension: 'pdf',
                contentSize: 8869,
                contentDocumentId: '069VB000003knIXYAY',
                category: null,
            },
        ],
    },
    {
        heading: 'Contacts and Clients Agreements',
        docs: [
            {
                className: 'DocumentLinkWrapper',
                title: 'TestDocument',
                linkedEntityId: 'a6XVB00dfghuio',
                latestPublishedVersionId: '068VB0000fgthyjukAA',
                id: 'edrtyuioert5y6789',
                fileType: 'WORD_X',
                fileExtension: 'docx',
                contentSize: 13117,
                contentDocumentId: 'dfghjkdfghjkl',
                category: null,
            },
            {
                className: 'DocumentLinkWrapper',
                title: 'sunset80280-248159',
                linkedEntityId: 'a6XVB0000007DF32AM',
                latestPublishedVersionId: '068VB0000040xvbYAA',
                id: '06AVB000004YCny2AG',
                fileType: 'JPG',
                fileExtension: 'jpg',
                contentSize: 1277350,
                contentDocumentId: '069VB000003pd2ZYAQ',
                category: null,
            },
            {
                className: 'DocumentLinkWrapper',
                title: 'TestPDF',
                linkedEntityId: 'a6XVB0000007DF32AM',
                latestPublishedVersionId: '068VB000003w5tdYAA',
                id: '06AVB000004YFjM2AW',
                fileType: 'PDF',
                fileExtension: 'pdf',
                contentSize: 8869,
                contentDocumentId: '069VB000003knIXYAY',
                category: null,
            },
        ],
    },
];

function LegalTemplates() {
    const data = useSelector(selectLegalTemplatesData);
    const status = useSelector(selectLegalTemplatesStatus);
    const error = useSelector(selectLegalTemplatesError);
    const dispatch = useDispatch();
    const theme = useTheme();

    useEffect(() => {
        if (status === 'idle') {
            dispatch(initializeAsync());
        }
    }, [status, dispatch]);

    const getCategoryData = () => {
        if (data.records?.length > 0) {
            let categoryData = {};
            for (let record of data.records) {
                let category = record.category || 'Others';
                if (!categoryData[category]) {
                    categoryData[category] = [];
                }
                categoryData[category].push(record);
            }

            return categoryData;
        }
        return {};
    };

    if (status === 'initialLoading') {
        return skeleton;
    }

    return (
        <MainContainer>
            <MainHeading>Legal Templates</MainHeading>
            {/* <ParaText marginTop={'0.5rem'}>
                Running a business involves many moving parts, and having the right legal documents on hand can make all the difference. This section provides easy access to commonly used templates
                that support everyday operations—like NDAs, service agreements, and employment documents—so you can stay protected and keep things running smoothly.
            </ParaText> */}
            <ParaText marginTop={'0.5rem'}>
                This collection of legal templates is designed to help simplify common business needs and save you time. These resources offer a solid starting point—but they’re not one-size-fits-all.
                Every business is unique, and legal requirements can vary, so be sure to review each document carefully and consult with a legal professional when needed to ensure your bases are
                covered.{' '}
            </ParaText>

            {Object.keys(getCategoryData())
                ?.sort()
                .map((key) => (
                    <Box marginTop={'3rem'}>
                        <Typography component={'h2'} variant="heading3" color={'text.primary'} marginBottom={'1rem'}>
                            {key}
                        </Typography>
                        <Box display={'flex'} flexWrap={'wrap'} marginLeft={'-0.5rem'}>
                            {getCategoryData()
                                [key]?.sort((a, b) => a.title?.localeCompare(b.title))
                                ?.map((cDoc) => (
                                    <DocumentCard docData={cDoc} />
                                ))}
                        </Box>
                    </Box>
                ))}
        </MainContainer>
    );
}

export default LegalTemplates;
